<template>
  <div class="wrapper animated fadeIn">
    <PageHeading title="User BTP Administration"></PageHeading>

    <div class="card card-default">
      <div class="card-header">
        <strong>Create New BTP User</strong>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="form-group required col-md-6">
            <label for="firstname">First Name</label>
            <input v-validate="'required'" type="text"
                   :class="{'form-control': true, 'is-invalid': (veeErrors.has('firstname') || errors.has('firstname')) }"
                   data-vv-as="First Name"
                   id="firstname" name="firstname" v-model="user.firstname"/>
            <small :v-show="veeErrors.has('firstname')"
                   class="text-danger">{{ veeErrors.first('firstname') || errors.first('firstname') }}</small>
          </div>
          <div class="form-group required col-md-6">
            <label for="lastname">Last Name</label>
            <input v-validate="'required'" type="text"
                   :class="{'form-control': true, 'is-invalid': (veeErrors.has('lastname') || errors.has('lastname')) }"
                   data-vv-as="Last Name"
                   id="lastname" name="lastname" v-model="user.lastname"/>
            <small :v-show="veeErrors.has('lastname')"
                   class="text-danger">{{ veeErrors.first('lastname') || errors.first('lastname') }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group required col-md-6">
            <label for="username">Username</label>
            <input v-validate="'required'" type="text"
                   :class="{'form-control': true, 'is-invalid': (veeErrors.has('username') || errors.has('username')) }"
                   data-vv-as="Username"
                   autocomplete="off" id="username" name="username" v-model="user.username"/>
            <small :v-show="veeErrors.has('username')"
                   class="text-danger">{{ veeErrors.first('username') || errors.first('username') }}</small>
          </div>
          <div class="form-group required col-md-6">
            <label for="email">Email</label>
            <input v-validate="'required|email'" type="text"
                   :class="{'form-control': true, 'is-invalid': (veeErrors.has('email') || errors.has('email')) }"
                   data-vv-as="Email"
                   autocomplete="off" id="email" name="email" v-model="user.email"/>
            <small :v-show="veeErrors.has('email')"
                   class="text-danger">{{ veeErrors.first('email') || errors.first('email') }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="password">Password</label>
            <div class="d-flex">
              <input v-validate="passwordValidations" :type="showPassword"
                     :class="{'form-control': true, 'is-invalid': (veeErrors.has('password') || errors.has('password')) }"
                     autocomplete="off" id="password" name="password"
                     data-vv-as="Password"
                     v-model="user.password"/>
              <button class="btn btn-basic" @click.prevent="toggleShowPassword"
                      v-if="user['password'] && user['password'].length > 0">
                <i class="fa fa-eye" v-if="showPassword === 'password'" title="Show Password"/>
                <i class="fas fa-lock" v-if="showPassword === 'text'" title="Hide Password"/>
              </button>
            </div>
            <small :v-show="veeErrors.has('password')"
                   class="text-danger">{{ veeErrors.first('password') || errors.first('password') }}</small>
          </div>
          <div class="form-group col-md-6">
            <label for="select_bases">Military Base</label>
            <select v-validate="'required'"
                    id="select_bases"
                    v-model="user.base_id"
                    name="base_id"
                    data-vv-as="Military Base"
                    :class="{'form-control': true, 'is-invalid': (veeErrors.has('base_id') || errors.has('base_id')) }">
              <option value="">- Select a military base -</option>
              <option v-for="base in bases" :key="base.id" :value="base.id">{{base.name}}</option>
            </select>
            <small :v-show="veeErrors.has('base_id')"
                   class="text-danger">{{ veeErrors.first('base_id') || errors.first('base_id') }}</small>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button type="button" class="btn btn-outline-secondary" @click.prevent="goBack">Cancel</button>
        <button type="button" class="btn btn-primary" :disabled="saving" @click.prevent="validateBeforeSubmit">Submit <i
            class="fas fa-spinner fa-pulse" v-if="saving"></i></button>
      </div>
    </div>
  </div>
</template>

<script>

import PageHeading from '../../../components/app/PageHeading';
import User from '../../../classes/Admin/User';
import {ValidationProvider, ErrorBag} from 'vee-validate';
import Bases from "../../../classes/military/Bases";

export default {
  data() {
    return {
      errors: new ErrorBag(),
      user: {
        firstname: null,
        lastname: null,
        email: null,
        username: null,
        password: null,
        base_id: null,
      },
      Bases: new Bases(),
      bases: null,
      saving: false,
      customMessages: {
        en: {
          custom: {
            'password': {
              regex: 'Password must contain at least one number and one special character.'
            }
          }
        }
      },
      passwordValidations: {
        regex: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^a-zA-Z0-9])[A-Za-z\d!@#$%^&*.,<>?:;\[\]{}=+\-_ &]/,
        min: 8,
        max: 40
      },
      showPassword: 'password'
    }
  },

  created() {
    this.$validator.localize(this.customMessages);
  },

  mounted() {
    this.getBases();
  },

  methods: {
    toggleShowPassword() {
      if (this.showPassword === 'password')
        this.showPassword = 'text'
      else
        this.showPassword = 'password'
    },

    getBases() {
      const self = this;
      this.Bases.index().then((response) => {
        self.bases = response.data;
      });
    },

    goBack() {
      this.$router.go(-1);
    },

    validateBeforeSubmit() {
      const self = this;
      this.saving = true;

      this.$validator.validateAll().then((validated) => {
        if (validated) {
          self.submitForm();
          return;
        }

        //feedback('Invalid data', 'danger');
        self.saving = false;
      });
    },

    submitForm() {
      const self = this;
      const user = new User();

      user.createMilitaryUser(this.user).then(function (response) {
        self.saving = false;

        if (response.errors && Object.keys(response.errors).length > 0) {
          Object.keys(response.errors).forEach(field => {
            self.errors.add({
              field: field,
              msg: Object.values(response.errors[field])[0]
            })
          });
        } else {
          self.$router.push({path: '/military/users'});
          feedback('BTP User Successfully Created');
        }
      });
    }
  },

  components: {
    PageHeading
  }
}
</script>

<style lang="scss" scoped>
label {
  font-weight: 700;
  color: #2b2b2b;
}

.form-group.required label:after {
  content: "*";
  position: relative;
  color: red;
  left: 0.15rem;
  top: -0.1rem;
  font-size: small;
}
</style>
